// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"115":"b72d049f","163":"50c1b9c4","194":"63776fb4","370":"af24f0bf","588":"dbb2a1f2","649":"0995a7ae","684":"c2066039","721":"2c9527cb","741":"e82ef1f2","743":"2aa5383b","787":"b7842dcd","896":"881a0002","921":"02e7bf6d","989":"399866b2"}[chunkId] + ".chunk.js";
};